var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('b-spinner',{staticStyle:{"width":"30px","height":"30px"},attrs:{"variant":"primary"}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('logout.out')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }